import React, { useCallback } from 'react';
import { Modal, TextContainer, Text } from "@shopify/polaris";
import { useAppDispatch, useAppSelector } from "../../../hooks/redux.js";
import { closeModal } from "../../../store/features/modal.js";
import { OPEN_MODAL_DUPLICATED_PRODUCTS } from "../../../constants/modalTypes.js";

const ActionIdInfoModal = () => {
    const dispatch = useAppDispatch();
    const { isOpen, modalType } = useAppSelector((state) => state.modal);

    const handleClose = useCallback(() => {
        dispatch(closeModal());
    }, [dispatch]);

    const handleRedirect = () => {
        window.open("https://stockhide.com/contact-us/", "_blank");
        dispatch(closeModal());
    };

    return (
        <Modal
            open={isOpen && modalType === OPEN_MODAL_DUPLICATED_PRODUCTS}
            onClose={handleClose}
            title="Important Update"
            primaryAction={{
                content: "Contact us",
                onAction: handleRedirect,
            }}
        >
            <Modal.Section>
                <TextContainer>
                    <Text variant="bodyMd" as="p">
                        Starting November 17, Stockhide will no longer allow products to be included in multiple actions. This change will help us avoid any issues when performing actions on your products.
                    </Text>
                    <Text variant="bodyMd" as="p">
                        We’ve noticed that your shop currently has this setup. To ensure a smooth transition, please remove products from any additional actions if they are already included in one, or delete any unnecessary actions. If you need assistance, feel free to reach out to us at hello@stockhide.com or click the button below.
                    </Text>
                </TextContainer>
            </Modal.Section>
        </Modal>
    );
};

export default ActionIdInfoModal;
